import styled from 'styled-components';
import { SLForm } from '~/pages/Sistema/componentes/SistemaList';
import { Colors } from '~/config/Colors';

export const Container = styled(SLForm)`
  width: 100%;
  max-width: 100%;

  .row {
    margin-bottom: 0.5em;

    .content-full {
      display: flex;
      flex-direction: column;
      padding: 1.5em 0em 2em 1em;

      .content-first {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 2.5em;

        .text {
          display: flex;
          flex-direction: column;

          .cod {
            font-size: 0.85em;
            font-weight: bold;
            color: ${Colors.Color4};
          }
          .bold {
            font-size: 0.8em;
            font-weight: bold;
            color: ${Colors.Color14};
          }
          .title {
            font-size: 0.75em;
            color: ${Colors.Color14};
          }
        }
        .info {
          display: flex;
          flex-direction: column;
          align-items: flex-end;

          .bold {
            font-size: 0.8em;
            font-weight: bold;
            color: ${Colors.Color14};
          }
          .title {
            font-size: 0.75em;
            color: ${Colors.Color14};
          }
        }
      }
      .content-second {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 2.5em;

        .text {
          display: flex;
          flex-direction: column;

          .bold {
            font-size: 0.8em;
            font-weight: bold;
            color: ${Colors.Color14};
          }
          .title {
            font-size: 0.75em;
            color: ${Colors.Color14};
          }
        }
      }
      .acordion {
        margin-top: 0.25em;
        margin-bottom: 0.25em;

        .despesa {
          display: flex;
          flex-direction: row;

          .title {
            font-size: 0.75em;
            color: ${Colors.Color14};
            margin-left: 0.5em;
          }
          img {
            width: 0.95em;
            height: 0.95em;
          }
        }
      }

      .content-third {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .text {
          display: flex;
          flex-direction: column;

          .bold {
            font-size: 0.8em;
            font-weight: bold;
            color: ${Colors.Color14};
          }
          .title {
            font-size: 0.75em;
            color: ${Colors.Color14};
          }
        }
      }
    }
  }

  .row-left {
    margin-bottom: 0.5em;
    display: flex;
    flex-direction: column;
    align-items: flex-end;,

  }

  .no-margin {
    margin: 0 !important;
  }

  .content-hour {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 1.5em;
    margin-top: 1.5em;

    .text {
      display: flex;
      align-items: center;
      flex-direction: column;

      .bold {
        font-size: 0.8em;
        font-weight: bold;
        color: ${Colors.Color14};
      }
      .title {
        font-size: 0.75em;
        color: ${Colors.Color14};
      }
    }
    .card-content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .card-cod {
        background: ${Colors.Color8};
        border-radius: 0.4em;
        padding: 0.1em 1.5em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 40%;

        .cod {
          font-size: 0.75em;
          font-weight: bold;
          color: ${Colors.Color4};
        }
      }
      .title {
        font-size: 0.75em;
        color: ${Colors.Color14};
      }
    }
  }

  .header {
    padding: 0 0.6em;
    margin-bottom: 1em;

    .h-descricao {
      font-size: 0.7125em;
      line-height: 0.8em;
      color: ${Colors.Color7};
    }
  }

  .title_p {
    text-align: left;
    margin-left: 1em;
    max-width: 100%;
    font-weight: 500;
    font-size: 0.75em;
    line-height: 1.8em;
    margin-bottom: 0.5em;
    color: ${Colors.Color7};
    ${props => props.row && `width: 6em; margin-bottom: 0em;`}
  }

  .novo-horario {
    background: ${Colors.Color4};
    padding: 0 1.7em;
    align-items: center;
    display: flex;
    justify-content: center;
    height: 2em;
    width: 60%;
    background-color: #34639c;
    border: 0.25em solid #34639c;
    border-radius: 0.5em;

    .adiciona-horario {
      font-size: 0.88em;
      font-weight: 500;
      color: white;
    }
  }

  .footer {
    position: fixed;
    bottom: 1em;
    left: 1em;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .card {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 8em;
    position: relative;
    box-shadow: 0px 6px 20px rgba(174, 177, 200, 0.07);
    margin-bottom: 1.5em;
    border-radius: 0.4em;

    .card-content {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      .card-cod {
        background: ${Colors.Color8};
        border-radius: 0.4em;
        padding: 0.2em 0.6em;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 31%;
        margin-top: 0.75em;
        margin-bottom: 1.25em;
        margin-left: 0.75em;

        .cod {
          font-size: 0.75em;
          font-weight: bold;
          color: ${Colors.Color4};
        }
      }
    }
    .content-body {
      display: flex;
      flex-direction: row;

      .start {
        display: flex;
        flex-direction: column;
        margin-left: 1em;

        .bold {
          font-size: 0.8em;
          font-weight: bold;
          color: ${Colors.Color14};
        }
        .title {
          font-size: 0.75em;
          color: ${Colors.Color14};
        }
      }
      .end {
        display: flex;
        flex-direction: column;
        margin-left: 3.5em;

        .bold {
          font-size: 0.8em;
          font-weight: bold;
          color: ${Colors.Color14};
        }
        .title {
          font-size: 0.75em;
          color: ${Colors.Color14};
        }
      }
    }
  }
`;
